/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { FETCH_SDK_LANGUAGES_REQUEST, FETCH_SDK_LANGUAGES_SUCCESS,
        FETCH_SDK_LANGUAGES_FAILURE, SdkAction } from '../types/sdk';

const initialState = {
    loading: true,
    languages: [],
    error: ''
}

const sdkReducer = (state = initialState, action: SdkAction ) => {
    switch (action.type){
        case FETCH_SDK_LANGUAGES_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_SDK_LANGUAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                languages: action.payload
            }
        case FETCH_SDK_LANGUAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload    
            }
        default:
            return state
    }
}

export default sdkReducer;
